import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MarketAssetComponent } from './market-asset.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
  ],
  exports: [
    MarketAssetComponent,
  ],
  declarations: [ MarketAssetComponent],
})
export class  MarketAssetComponentModule {}
